// extracted by mini-css-extract-plugin
export default {"home":"Home_home__+4hQq","heroBg":"Home_heroBg__jXhvZ","heroPatt":"Home_heroPatt__lparY"};